module.exports = __webpack_public_path__ + "static/img/hebei.1ac1d8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/hebei.png
// module id = sORZ
// module chunks = 93